/**
 * Coupon Background Configuration
 *
 * Preset background options for coupon creation.
 * Merchants select from this gallery instead of uploading custom images (MVP).
 *
 * Note: Background URLs should point to images stored in Vercel Blob.
 * To update: Upload images to Vercel Dashboard → Storage → Blob, then update URLs here.
 */

interface CouponBackground {
	id: string;
	nameKey: string; // i18n translation key
	url: string | null; // null for "No Background"
}

export const COUPON_BACKGROUNDS: CouponBackground[] = [
	// "No Background" option - must be first
	{ id: 'none', nameKey: 'coupon.background.none', url: null },

	// Gradient backgrounds
	{ id: 'gradient-gold', nameKey: 'coupon.background.goldGradient', url: '/backgrounds/gold-gradient.jpg' },
	{ id: 'gradient-blue', nameKey: 'coupon.background.blueGradient', url: '/backgrounds/blue-gradient.jpg' },
	{ id: 'gradient-purple', nameKey: 'coupon.background.purpleGradient', url: '/backgrounds/purple-gradient.jpg' },
	{ id: 'gradient-warm', nameKey: 'coupon.background.warmGradient', url: '/backgrounds/warm-gradient.jpg' },
	{ id: 'gradient-green', nameKey: 'coupon.background.greenGradient', url: '/backgrounds/green-gradient.jpg' },

	// Celebratory/promotional backgrounds
	{ id: 'confetti', nameKey: 'coupon.background.celebration', url: '/backgrounds/celebration.jpg' },
];

// Default background when none is selected
export const DEFAULT_BACKGROUND: CouponBackground = COUPON_BACKGROUNDS[0];

export type { CouponBackground };
